module.exports = __webpack_public_path__ + "img/order-up.11c71dac.svg";